import SessionModel from "../../stores/SessionModel";

export function isAdmin(): boolean {
    if (SessionModel.getCurrentUserAuthData().roles.includes("ROLE_ADMIN")) {
        return true;
    } else {
        return false;
    }
}